<template>
	<div class="page-form">


		<div class="titleContainer" v-show="title">
			<h1 v-if="title">
				<div class="dummy1"></div>
				{{title}}
				<div class="dummy2"></div>
			</h1>
		</div>


		<div class="pageSubtitle">{{subtitle}}</div>

		<slot name="content"></slot>
		<slot name="nav"></slot>

	</div>
</template>

<!-- ================================================================================== -->

<script>
	export default {
		name:"PageForm",
		components: {},
		props: {
			title: {
				type: String,
				required: false,
			},
			subtitle: {
				type: String,
				required: false,
			},
		}
	}
</script>

<!-- ================================================================================== -->

<style lang="scss" scoped>
</style>
